import React, { useState, useEffect } from 'react'
import api from "../api/dataSource"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col
} from 'reactstrap';
import classnames from 'classnames'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import Equipos from './Equipos'
import Resultados from './Resultados'

const CampeonatoResumen = ({ idCampeonato }) => {
	const [activeTab, setActiveTab] = useState('1')
	const [fixtureLista, setFixtureLista] = useState([])
	const MySwal = withReactContent(Swal)
	const toggle = tab => {
    if(activeTab !== tab) setActiveTab(tab);
  }

  const getFixture = (campeonatoid) => {
  	MySwal.showLoading();
    MySwal.disableButtons();
    api.getCampeonato(`api/obtener_fixture_pagina/${campeonatoid}`).then((resp) => {
    	setFixtureLista(resp)
    	MySwal.close()
    }).catch(error => {
      MySwal.close()
    })
  }

  const formatUsDate = (date) => {
	  const fecha = date.split('-')
	  return `${fecha[2]}/${fecha[1]}/${fecha[0]}`
	}

  const numero = 1
  useEffect(() => {
  	getFixture(idCampeonato)
  }, [numero])

	return (
		<Card>
      <CardBody>
				<Nav tabs>
		      <NavItem>
		        <NavLink style={{cursor: 'pointer'}} className={classnames({ active: activeTab === '1' })} onClick={() => { toggle('1'); }}>
		          Fixture
		        </NavLink>
		      </NavItem>
		      <NavItem>
		        <NavLink  style={{cursor: 'pointer'}} className={classnames({ active: activeTab === '2' })} onClick={() => { toggle('2'); }}>
		          Equipos/Jugadores
		        </NavLink>
		      </NavItem>
					<NavItem>
		        <NavLink  style={{cursor: 'pointer'}} className={classnames({ active: activeTab === '3' })} onClick={() => { toggle('3'); }}>
		          Resultados
		        </NavLink>
		      </NavItem>
		    </Nav>
		    <TabContent activeTab={activeTab}>
		      <TabPane tabId="1">
		        <Row>
		          <Col sm="12">
		            <div className="row">
		            	<div className="col-md-12">
			              <div className="ec-fancy-title">
			                 <h2>Fixture y Resultados</h2>
			              </div>
			              <div className="ec-fixture-list ec-matches-list">
                			<ul style={{paddingInlineStart: '0'}}>
                				{
                					fixtureLista.map((x, i) => (
                						<li key={x.id}>
		                          <div className={`ec-cell ${i % 2 === 0 ? 'celdax' : ''}`}>
		                          	<span>{x.fase === 'Grupos' ? `Grupo ${x.local_equipo?.grupo}` : x.fase} - Fecha: {formatUsDate(x.fecha)} - Hora: {x.hora}</span>
		                          </div>
		                          <div className={`ec-cell ${i % 2 === 0 ? 'celdax' : ''}`}>
		                          	<Row>
		                          		<Col>
		                          			{
		                          				!!x.localx.foto
		                          				? (
		                          					<img
				                              		style={{ width: '50px' }}
								                          src={`data:image/jpeg;base64,${x.localx.foto}`} className="avatar"
								                          alt="Logo"
								                        />
		                          				)
		                          				: (
		                          					<img style={{ width: '50px' }} src="SINLOGO.png" className="avatar" alt="Logo" />
		                          				)
		                          			}
			                              {x.localx.nombre}
		                          		</Col>
		                          		{
		                          			!!x.partido
		                          			? (
		                          				<strong className="marcador">
					                          		{`${x.partido.localMarcador} - ${x.partido.visitanteMarcador}`}
					                          	</strong>
		                          			)
		                          			: (
		                          				<span className="ec-fixture-vs">
				                              	<small>vs</small>
				                              </span>
		                          			)
		                          		}
		                          		<Col>
			                          		{
																			!!x.visitantex.foto
		                          				? (
		                          					<img
				                              		style={{ width: '50px' }}
								                          src={`data:image/jpeg;base64,${x.visitantex.foto}`} className="avatar"
								                          alt="Logo"
								                        />
		                          				)
		                          				: (
		                          					<img style={{ width: '50px' }} src="SINLOGO.png" className="avatar" alt="Logo" />
		                          				)
			                          		}
						                        {x.visitantex.nombre}
		                          		</Col>
		                          	</Row>
		                          </div>
		                          <div style={{textAlign: 'center'}} className={`ec-cell ${i % 2 === 0 ? 'celdax' : ''}`}>
		                          	<strong>
		                          		{
		                          			!!x.partido
		                          			? (
		                          				x.partido.finalizado ? 'FINALIZADO' : 'EN PROGRESO'
		                          			)
		                          			: (
		                          				'PENDIENTE'
		                          			)
		                          		}
		                          	</strong>
		                          </div>
		                          {/*<div style={{textAlign: 'center'}} className={`d-block d-xs-block d-md-none ec-cell ${i % 2 === 0 ? 'celdax' : ''}`}>
		                          	<strong className="marcador">
		                          		3 - 0
		                          	</strong>
		                          </div>*/}
			                      </li>
                					))
                				}
		                  </ul>
			              </div>
				          </div>
		            </div>
		          </Col>
		        </Row>
		      </TabPane>
		      <TabPane tabId="2">
		      	<Equipos idCampeonato={idCampeonato} />
		      </TabPane>
					<TabPane tabId="3">
						<Resultados idCampeonato={idCampeonato} />
		      </TabPane>
		    </TabContent>
      </CardBody>
     </Card>
	)
}

export default CampeonatoResumen
